import ProfileService from '../services/permissions.service';

const profileGuard = {
  'profile-guard': {
    inserted: async function(el, binding, vnode) {
      const action = binding.value;
      const allow = await ProfileService.canExecute(action);
      if (!allow) {
        vnode.elm.parentElement.removeChild(vnode.elm);
      }
    }
  }
};

export { profileGuard };
